/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { JSEncrypt } from 'jsencrypt'
import { put, takeEvery } from 'redux-saga/effects'
import { AuthConst } from '@/store/constant/auth.constant'
import { getPublicKey, signInRequest, authToken, signOutRequest, getShiro, saveLogin, simulation } from '@/services/auth.service'
import { IJwt, IToken, ISigninAction, IAuthAction, ISignoutAction, IUserInfo, ISetAuthAction, IGetAuthAction } from '@/store/models/auth.model'
import { getAuth, setAuth, setUserInfo, signinFail, signinSuccess, signupFail, signupSuccess } from '@/store/actions/auth.action'
import { dateTime, compile } from '@/utils/util'
import { requestStatus } from '@/store/actions/common.action'
import moment from 'moment'
import { isAuth } from '@/utils/auth'
import { getDicOfClass } from '@/services/table.service'
import { getSessionAll } from '@/services/rag'
import { setDicClassList } from '@/store/actions/tableEdit.action'
import type { IClassOptionResData } from '@/store/models/tableEdit.model'

// function* hanleSignup(action: SignupAction): unknown {
//     try {
//         yield axios.post(`${API}/signup`, action.payload)
//         yield put(signupSuccess())
//     } catch (error: any) {
//         yield put(signupFail(error.response.data.error))
//     }
// }
export const getErrorStr = (error: string 
    | { message: string } 
    | { msg: string }): string => {
    let str = ''
    if (typeof error === 'string') {
        str = error
    } else if ('message' in error) {
        str = error.message
    } else {
        str = error.msg
    }
    localStorage.removeItem('userInfo')
    return str
}

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
function* saveLoginFn (param?: IJwt) {
    const sessionLogin = sessionStorage.getItem('loginNum')
    let obj: Record<string, number> = {}
    if (param) {
        if (sessionLogin) {
            obj = JSON.parse(sessionLogin)
            obj[param.login]++
        } else {
            obj[param.login] = 1
            saveLogin({
                user: compile(param.login),
                time: moment().format('YYYY-MM-DD')
            })
        }
    } else {
        const localStorageStr = localStorage.getItem('userInfo')
        let localStorageUserInfo = {
            token: '',
            login: ''
        }
        if (localStorageStr) {
            localStorageUserInfo = JSON.parse(localStorageStr)
        }
        const userInfo: IUserInfo = yield isAuth()
        // 通过 token 获取 userInfo 后
        // 如果没有登录，则更新保存用户信息
        const userInfoLocal: IJwt = {
            token: localStorageUserInfo.token,
            email: userInfo.email,
            login: userInfo.login,
            nickName: userInfo.nickName,
            phone: userInfo.phone,
            userId: userInfo.userId,
            avatar: userInfo.avatar ?? '',
        }
        localStorage.setItem('userInfo', JSON.stringify(userInfoLocal))
        
        yield put(setUserInfo(userInfo))
        saveLogin({
            user: compile(userInfo.login),
            time: moment().format('YYYY-MM-DD')
        })
        if (sessionLogin) {
            obj = JSON.parse(sessionLogin)
            obj[localStorageUserInfo.login]++
        } else {
            obj[userInfo.login] = 1
        }
    }
    sessionStorage.setItem('loginNum', JSON.stringify(obj))
}

// 点击登录
function* handleSignin(action: ISigninAction): unknown {
    try {
        let userInfo: IUserInfo
        if (!action.payload.simulation) {
            const clientId = 'ITMT20220922'
            const publicKey: string = yield getPublicKey()
            const jSEncrypt = new JSEncrypt()
            jSEncrypt.setPublicKey(publicKey)
            const username = jSEncrypt.encrypt(dateTime() + action.payload.username) as string
            const password = jSEncrypt.encrypt(dateTime() + action.payload.password) as string
            userInfo = yield signInRequest({
                ...action.payload,
                clientId,
                username,
                password
            })
        } else {
            userInfo = yield simulation({
                username: action.payload.username
            })
            // 设置模拟登录模式
            userInfo.simulation = true
        }
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        sessionStorage.setItem('loginNum', JSON.stringify({
            [userInfo.login]: 1
        }))
        localStorage.removeItem('persist:reducer')
        // 重新获取权限
        yield put(getAuth())
        yield put(signinSuccess(action.payload.message))
        yield put(setUserInfo(userInfo))

        if (!action.payload.simulation) {
            saveLogin({
                user: compile(action.payload.username),
                p: compile(action.payload.password as string),
                time: moment().format('YYYY-MM-DD')
            })
            // 获取字典
            const dicArr = ['release status', 'research form', 'priority', 'status-year', 'tmt approval',
                'maturity', 'requirement source', '相关BU', '技术成熟度', '专利状态']
            const promiseArr = dicArr.map(item => getDicOfClass({
                className: item,
                status: 1
            }))
            const resArr = yield Promise.all<Promise<IClassOptionResData[]>>(promiseArr)
            const obj: {
                [propertys: string]: IClassOptionResData[]
            } = {}
            dicArr.forEach((item, index) => {
                obj[item] = resArr[index]
            })
            yield put(setDicClassList(obj))
        }
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(signinFail(str))
    }
}

// 验证登录或跳转时传 token 过来
function* handleAuthSignin(action: IAuthAction): unknown {
    try {
        // 如果不是通过带 token 跳转的,就不用设置,只做验证
        if (action.payload) {
            const userInfoStr = localStorage.getItem('userInfo')
            if (userInfoStr) {
                const userInfoLocal: IJwt = JSON.parse(userInfoStr)
                userInfoLocal.token = action.payload
                localStorage.setItem('userInfo', JSON.stringify(userInfoLocal))
                yield authToken()
            } else {
                localStorage.setItem('userInfo', JSON.stringify({ token: action.payload }))
                yield authToken()
            }
        } else {
            // 直接使用原有 token 验证
            yield authToken()
            yield put(requestStatus(false))
        }
        yield put(signinSuccess(''))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(signinFail(str))
    }
}

// 登出
function* handleSignout(action: ISignoutAction): unknown {
    try {
        yield signOutRequest()
        yield put(signupSuccess(action.message))
        yield put(setUserInfo(null))
        localStorage.removeItem('userInfo')
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(signupFail(str))
    }
}

// 获取权限
function* handleGetAuth(action: IGetAuthAction): unknown {
    try {
        const res = yield getShiro(action.payload?.websiteUrl)
        yield put(setAuth(res))
    } catch (error: any) {
        const str = getErrorStr(error)
        yield put(signupFail(str))
    }
}

export default function* authSaga(): unknown {
    // 登录
    yield takeEvery(AuthConst.SIGNIN, handleSignin)
    // 验证登录或跳转时传 token 过来
    yield takeEvery(AuthConst.AUTHTOKEN, handleAuthSignin)
    // 登出
    yield takeEvery(AuthConst.SIGNUP, handleSignout)
    // 获取权限
    yield takeEvery(AuthConst.GETAUTH, handleGetAuth)
}
